// Generated by CoffeeScript 1.9.1

/*
Given an execution environment (exe) create a list of
queries that can execute locally, and another list of
queries to execute somewhere else.
 */
var canexecute, missingproviders;

canexecute = require('./canexecute');

missingproviders = require('./missingproviders');

module.exports = function(exe, queries) {
  var key, local, missing, query, remote;
  local = {};
  remote = {};
  missing = {};
  for (key in queries) {
    query = queries[key];
    if (canexecute(exe, query)) {
      local[key] = query;
    } else {
      remote[key] = query;
      missing[key] = missingproviders(exe, query);
    }
  }
  return {
    local: local,
    remote: remote,
    missing: missing
  };
};
